(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header-jewelry"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) this.searchModal.close();
    }
  }

  customElements.define('sticky-header', StickyHeader);

  // header-jewelry専用のホバーメニュー処理 - デバッグ強化版
  function initHoverMenu() {
    console.log('=== ホバーメニュー処理開始 ===');
    
    // 全ての可能なセレクタをテスト
    const headerOnDo = document.querySelector('.header-jewelry');
    const allHeaders = document.querySelectorAll('.header');
    const allHeaderMenus = document.querySelectorAll('header-menu');
    
    console.log('header-jewelry要素:', headerOnDo);
    console.log('全てのheader要素数:', allHeaders.length);
    console.log('全てのheader-menu要素数:', allHeaderMenus.length);
    
    if (!headerOnDo) {
      console.log('header-jewelryが見つからない - 再試行中...');
      setTimeout(initHoverMenu, 200);
      return;
    }

    // header-jewelry内のメニューを探索
    const menuItems = headerOnDo.querySelectorAll('header-menu');
    const alternativeMenuItems = headerOnDo.querySelectorAll('.header__inline-menu .list-menu__item');
    
    console.log('header-jewelry内のheader-menu数:', menuItems.length);
    console.log('代替メニューアイテム数:', alternativeMenuItems.length);
    
    // デスクトップレイアウトの存在確認
    const desktopLayout = headerOnDo.querySelector('.header-jewelry__desktop-layout');
    console.log('デスクトップレイアウト:', desktopLayout);
    
    if (menuItems.length === 0) {
      console.log('メニューアイテムが見つからない - 再試行中...');
      setTimeout(initHoverMenu, 200);
      return;
    }
    
    menuItems.forEach(function(menuItem, index) {
      console.log('=== メニューアイテム', index, 'の処理開始 ===');
      
      const details = menuItem.querySelector('details');
      // メガメニューの場合は .mega-menu__content を探す
      const submenu = details ? (details.querySelector('.mega-menu__content') || details.querySelector('.header__submenu')) : null;
      const summary = details ? details.querySelector('summary') : null;
      
      console.log('details要素:', details);
      console.log('submenu要素:', submenu);
      console.log('summary要素:', summary);
      console.log('detailsのクラス:', details ? details.className : 'なし');
      
      if (!details || !submenu || !summary) {
        console.log('必要な要素が見つからない:', {details, submenu, summary});
        return;
      }

      console.log('メニューアイテム', index, 'のイベントリスナー設定中...');

      // 既存のイベントリスナーを削除（重複防止）
      menuItem.removeEventListener('mouseenter', menuItem._hoverEnter);
      menuItem.removeEventListener('mouseleave', menuItem._hoverLeave);

      // イベント関数を保存
      menuItem._hoverEnter = function(e) {
        console.log('🎯 MOUSEENTER:', index, menuItem);
        
        // ホバー状態フラグを設定
        menuItem._isHovered = true;
        
        // 全ての方法で表示を試行
        details.setAttribute('open', '');
        details.open = true;
        summary.setAttribute('aria-expanded', 'true');
        
        // 直接スタイル適用
        submenu.style.cssText = `
          display: block !important;
          visibility: visible !important;
          opacity: 1 !important;
          transform: translateY(0) !important;
          z-index: 1000 !important;
          position: absolute !important;
        `;
        
        console.log('表示後のsubmenu状態:', {
          display: submenu.style.display,
          visibility: submenu.style.visibility,
          opacity: submenu.style.opacity,
          open: details.hasAttribute('open')
        });
      };

      menuItem._hoverLeave = function(e) {
        console.log('🎯 MOUSELEAVE:', index, menuItem);
        
        // ホバー状態フラグをクリア
        menuItem._isHovered = false;
        
        // 少し遅延してから閉じる（メガメニュー内への移動を許可）
        setTimeout(function() {
          // メガメニューがホバーされている場合は閉じない
          if (!menuItem._isHovered && !submenu.matches(':hover')) {
            details.removeAttribute('open');
            details.open = false;
            summary.setAttribute('aria-expanded', 'false');
            
            submenu.style.cssText = `
              display: none !important;
              visibility: hidden !important;
              opacity: 0 !important;
              transform: translateY(-1.5rem) !important;
            `;
          }
        }, 100);
      };

      // メガメニュー自体のホバーイベント
      submenu.addEventListener('mouseenter', function() {
        console.log('🎯 SUBMENU MOUSEENTER:', index);
        menuItem._isHovered = true;
      });

      submenu.addEventListener('mouseleave', function() {
        console.log('🎯 SUBMENU MOUSELEAVE:', index);
        menuItem._isHovered = false;
        
        // メニューアイテムもホバーされていない場合は閉じる
        setTimeout(function() {
          if (!menuItem._isHovered && !menuItem.matches(':hover')) {
            details.removeAttribute('open');
            details.open = false;
            summary.setAttribute('aria-expanded', 'false');
            
            submenu.style.cssText = `
              display: none !important;
              visibility: hidden !important;
              opacity: 0 !important;
              transform: translateY(-1.5rem) !important;
            `;
          }
        }, 100);
      });

      // イベントリスナーを追加
      menuItem.addEventListener('mouseenter', menuItem._hoverEnter);
      menuItem.addEventListener('mouseleave', menuItem._hoverLeave);
      
      // クリック時のリンク遷移機能を追加
      summary.addEventListener('click', function(e) {
        console.log('🔗 MENU CLICK:', index, summary);
        
        // デフォルトのドロップダウン動作を停止
        e.preventDefault();
        e.stopPropagation();
        
        // data-*属性やid属性からリンク先を推測
        const menuId = summary.id; // e.g., "HeaderMenu-women"
        const menuHandle = menuId ? menuId.replace('HeaderMenu-', '') : '';
        
        console.log('メニューハンドル:', menuHandle);
        
        if (menuHandle) {
          // 特定のメニューハンドルに対して専用のURL設定
          let linkUrl = '';
          
          if (menuHandle === 'women' || menuHandle === 'woman') {
            linkUrl = '/collections/womens-clothing';
          } else if (menuHandle === 'men' || menuHandle === 'mans') {
            linkUrl = '/collections/mens-clothing';
          } else {
            // その他のメニューは標準的なURL構造を使用
            linkUrl = `/collections/${menuHandle}`;
          }
          
          // JEWELRYパラメータを追加
          linkUrl += '?jewelry';
          
          console.log('遷移先URL:', linkUrl);
          
          // リンクに遷移
          window.location.href = linkUrl;
        } else {
          // フォールバック：メニューテキストから推測
          const menuTitle = summary.textContent.trim().toLowerCase();
          console.log('メニュータイトル:', menuTitle);
          
          let collectionName = '';
          if (menuTitle.includes('woman') || menuTitle.includes('women')) {
            collectionName = 'womens-clothing';
          } else if (menuTitle.includes('men') || menuTitle.includes('mans')) {
            collectionName = 'mens-clothing';
          } else if (menuTitle.includes('accessor')) {
            collectionName = 'accessories';
          } else {
            // デフォルト：小文字に変換
            collectionName = menuTitle.replace(/\s+/g, '-').toLowerCase();
          }
          
          const fallbackUrl = `/collections/${collectionName}?jewelry`;
          console.log('フォールバックURL:', fallbackUrl);
          window.location.href = fallbackUrl;
        }
      });
      
      console.log('✅ メニューアイテム', index, 'のイベントリスナー設定完了');
    });
    
    console.log('=== 全メニューアイテムの処理完了 ===');
  }

  // 複数のタイミングで初期化を試行
  document.addEventListener('DOMContentLoaded', function() {
    console.log('DOMContentLoaded - 初期化開始');
    initHoverMenu();
  });
  
  window.addEventListener('load', function() {
    console.log('window.load - 初期化開始');
    setTimeout(initHoverMenu, 100);
  });
  
  // 遅延実行でも試行
  setTimeout(function() {
    console.log('遅延実行 - 初期化開始');
    initHoverMenu();
  }, 1000);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
